<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Planificacion de producción</h1>
        </b-col>
        <b-col>
          <div>
            <b-form>
              <b-row>
                <b-col>
                  <label for="monthSelect">Mes</label>
                  <b-form-select
                    id="monthSelect"
                    v-model="selected.month"
                    :plain="true"
                    :options="selectOptions.months"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
                <b-col>
                  <label for="yearSelect">Año</label>
                  <b-form-select
                    id="yearSelect"
                    v-model="selected.year"
                    :plain="true"
                    :options="selectOptions.years"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-col>
      </b-row>
      <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
        <template slot="afterFilter">
          <tr class="VueTables__no-results">
            <b-button @click.prevent="resetFilters">Limpiar filtro</b-button>
          </tr>
          <tr v-if="loading" class="VueTables__no-results">
            <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
          </tr>
        </template>
        <template #actions="row">
          <production-plan-report :id="row.row.id"></production-plan-report>
          <material-list
            v-if="row.row.config"
            :id="row.row.id"
            :container_id="row.row.config.ops[0].container.id"
            :container_name="row.row.config.ops[0].container.name"
            :container_sku="row.row.config.ops[0].container.sku"
            :total_quantity="row.row.config.ops[0].selected_boxes"
          ></material-list>
          <a
            href="#"
            @click.prevent="
              $router.push({
                name: 'procesos-crear-plan-produccion',
                params: { purchaseOrderId: row.row.config.ops[0].id, id: row.row.id }
              })
            "
            ><i class="fa fa-lg fa-edit"></i
          ></a>
          <a href="#" @click.prevent="deleteProductionPlan(row.row.id)"
            ><i class="fa fa-lg fa-trash text-danger ml-2"></i
          ></a>
        </template>
        <template #completed="row"> {{ getConsumed(row.row.content_set) }}/{{ row.row.content_set.length }} </template>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import tableTexts from "../../../lang/tableTexts";
import ProductionPlanReport from "./ProductionPlanReport";
import MaterialList from "./MaterialList";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "PurchaseOrder",
  components: {
    ServerTable,
    ProductionPlanReport,
    MaterialList
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
      this.ready = true;
    });

    this.loadYear();
    this.getSelectionSet();
    moment.locale("es");
  },
  data() {
    return {
      ready: false,
      loading: true,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer_name"
      },
      columns: ["id", "date", "completed", "actions"],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        products: [],
        product_types: [],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      options: {
        columnsClasses: {
          id: "text-center",
          date: "text-center",
          completed: "text-center",
          actions: "text-center"
        },
        templates: {
          date: function (row) {
            return moment(row.date).format("DD-MM-YYYY");
          }
        },
        skin: "table table-sm table-hover table-striped  border-1 table-fixed",
        debounce: 800,
        // skin: "table table-sm table-hover border-0",
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        rowAttributesCallback: function (row) {
          const date = moment(row.delivery_date).format("DD-MM-YYYY");
          // row.delivery_date = date;
        },

        texts: tableTexts,
        perPage: 25,
        perPageValues: [15, 25, 50, 100],
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["client_customer__name", "plan__subplan", "status"],
        listColumns: {
          status: [
            { text: "vigente", id: "vigente" },
            { text: "cancelado", id: "cancelado" },
            { text: "completado", id: "completado" }
          ],
          client_customer_name: []
        },
        headings: {
          id: "ID",
          client_customer__name: "Cliente",
          delivery_date: "Fecha de entrega",
          priority: "Prioridad",
          plan__week: "Semana",
          plan__subplan: "Programa",
          completed_kilograms: "Kgs. completados",
          kilograms: "Kgs. totales",
          remaining_kilograms: "Kgs. restantes",
          quantity: "Cajas",
          status: "Estado",
          progress: "Progreso",
          actions: "Acciones"
        },
        initFilters: {
          status
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  // watch: {
  //   url(val, oldVal) {
  //     this.$refs.table.refresh();
  //   }
  // },
  computed: {
    name() {
      return "PP " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    url() {
      const expand = "expand=content_set&";
      const fields = "fields=id,date,content_set.status_content,config&";
      return `/api/v1/production_plan/?${expand}${fields}month=${this.selected.month}&year=${this.selected.year}`;
    }
  },
  methods: {
    getConsumed(content_set) {
      let consumed = 0;
      for (let item of content_set) {
        if (!item.status_content) {
          consumed++;
        }
      }
      return consumed;
    },
    deleteProductionPlan(id) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        // cancelButtonColor: "#d33",
        confirmButtonText: "¡Sí, bórralo!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.value) {
          this.confirmDeleteProductionPlan(id);
        }
      });
    },
    async confirmDeleteProductionPlan(id) {
      this.loading = true;
      try {
        const response = await this.$axios.delete("/api/v1/production_plan/" + id + "/");
        if (response.status == 204) {
          this.$bvToast.toast("Plan de producción eliminado", {
            title: "Éxito",
            variant: "success",
            solid: true
          });
          this.$refs.table.refresh();
        }
      } catch (error) {
        this.$bvToast.toast("No se pudo eliminar el plan de producción", {
          title: "Error",
          variant: "danger",
          solid: true
        });
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    sumColumn(column) {
      let total = 0;
      const data = this.$refs.table;
      if (data) {
        total += data.data.reduce((acc, item) => acc + parseFloat(item[column]), 0);
      }
      return total;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    async fetchData() {
      const response = await this.$axios.get(this.url);
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
    loadYear() {
      for (let ano = 2017; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
